import { Divider, useTheme } from '@mui/material'

export const DividerStyled = ({ sx }) => {
  const { palette } = useTheme()

  return <Divider sx={{ my: '16px', borderColor: palette?.grey?.[1], ...sx }} />
}
